import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { LineItemView } from 'ish-core/models/line-item/line-item.model';
import { OrderLineItem } from 'ish-core/models/order/order.model';

@Component({
  selector: 'custom-edit-line-item',
  templateUrl: './custom-edit-line-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, FaIconComponent, AsyncPipe, TranslateModule],
})
export class CustomEditLineItemComponent implements OnInit {
  private context = inject(ProductContextFacade);

  readonly link = input(true);
  readonly pli = input<Partial<LineItemView & OrderLineItem>>(undefined);
  readonly icon = input<IconProp>(['fas', 'pencil']);

  productURL$: Observable<string>;
  productName$: Observable<string>;

  ngOnInit() {
    this.productURL$ = this.context.select('productURL');
    this.productName$ = this.context.select('product', 'name');
  }
}
